"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const CreditCardAssignmentsProvider_1 = require("./CreditCardAssignmentsProvider");
/* eslint-disable @typescript-eslint/ban-ts-ignore */
// @ts-ignore
const credit_card_type_1 = tslib_1.__importDefault(require("credit-card-type"));
const ApiClient_1 = require("../lib/ApiClient");
class CCBillPurchaseProvider extends DataProvider_1.default {
    tokenizeCreditCard(paymentSystemId, billingDetails) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const creds = yield this.query("ccbillPrepareTokenRequest", { systemId: paymentSystemId }, `... on CCBillTokenRequest {
        accountId
        subAccountId
        apiAccessToken
        email
        ipAddress
      }`);
            const configs = [
                { url: "https://api.ccbill.com/payment-tokens/merchant-only", receiveErrors: false },
                { url: "https://ccbill.eu-cloud.scrile.com/payment-tokens/merchant-only", receiveErrors: true },
            ];
            let paymentToken = "";
            for (let config of configs) {
                this.setReceiveErrors(config.receiveErrors);
                try {
                    paymentToken = (yield (yield this.fetch(config.url, {
                        cache: "no-cache",
                        method: "POST",
                        headers: {
                            "Authorization": "Bearer " + creds.apiAccessToken,
                            "Content-Type": "application/json",
                            "Accept": "application/vnd.mcn.transaction-service.api.v.2+json",
                        },
                        body: JSON.stringify({
                            clientAccnum: creds.accountId,
                            clientSubacc: creds.subAccountId,
                            customerInfo: {
                                customerFname: billingDetails.firstName,
                                customerLname: billingDetails.lastName,
                                address1: billingDetails.address,
                                address2: "",
                                city: billingDetails.city,
                                state: billingDetails.state,
                                zipcode: billingDetails.zip,
                                country: billingDetails.country,
                                email: creds.email,
                                ipAddress: creds.ipAddress,
                            },
                            paymentInfo: {
                                creditCardPaymentInfo: {
                                    cardNum: billingDetails.cardNumber,
                                    expMonth: ("0" + billingDetails.expMonth).substr(-2),
                                    expYear: billingDetails.expYear,
                                    cvv2: billingDetails.cvc,
                                    nameOnCard: (billingDetails.firstName + " " + billingDetails.lastName).trim(),
                                },
                            },
                            subscriptionId: 0,
                        }),
                    }, (res) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        const responseBody = yield res.text();
                        try {
                            const json = JSON.parse(responseBody);
                            if (json.errors && json.errors.length > 0) {
                                return json.errors.map((err) => ApiClient_1.ApiClient.defaultError(res.status, err.message));
                            }
                            else {
                                return [ApiClient_1.ApiClient.defaultError(res.status, json.generalMessage, responseBody)];
                            }
                        }
                        catch (e) {
                            // eslint-disable-next-line no-console
                            console.warn("Could not parse CCBill error", e);
                        }
                        return [ApiClient_1.ApiClient.defaultErrorParser(res.status, responseBody)];
                    }))).json()).paymentTokenId;
                    break;
                }
                catch (e) {
                    if (config.receiveErrors)
                        throw e;
                }
            }
            return {
                paymentToken,
                cardNumberEnding: billingDetails.cardNumber.substr(-4),
                cardType: CCBillPurchaseProvider.getCreditCardType(billingDetails.cardNumber),
                firstName: billingDetails.firstName,
                lastName: billingDetails.lastName,
                address: billingDetails.address,
                city: billingDetails.city,
                state: billingDetails.state,
                zip: billingDetails.zip,
                country: billingDetails.country,
            };
        });
    }
    static getCreditCardType(cardNumber) {
        const type = credit_card_type_1.default(cardNumber);
        if (type.length < 1)
            return CreditCardAssignmentsProvider_1.CreditCardType.OTHER;
        switch (type[0].type) {
            case "visa":
                return CreditCardAssignmentsProvider_1.CreditCardType.VISA;
            case "mastercard":
                return CreditCardAssignmentsProvider_1.CreditCardType.MASTERCARD;
            case "american-express":
                return CreditCardAssignmentsProvider_1.CreditCardType.AMEX;
            case "diners-club":
                return CreditCardAssignmentsProvider_1.CreditCardType.DINERS;
            case "discover":
                return CreditCardAssignmentsProvider_1.CreditCardType.DISCOVER;
            default:
                return CreditCardAssignmentsProvider_1.CreditCardType.OTHER;
        }
    }
    assignCreditCard({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const tokenizedData = yield this.tokenizeCreditCard(data.paymentSystemId, data.billingDetails);
            return this.mutate("ccbillAssignCreditCard", { data: tokenizedData }, this.getFragment("CreditCardAssignment"));
        });
    }
    purchaseDeposit({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (data.billingDetails !== undefined) {
                const tokenizedBillingDetails = Object.assign(Object.assign({}, (yield this.tokenizeCreditCard(data.paymentSystemId, data.billingDetails))), { saveCard: data.billingDetails.saveCard });
                const tokenizedPurchaseData = {
                    billingDetails: tokenizedBillingDetails,
                    pricePackageId: data.pricePackageId,
                    paymentSystemId: data.paymentSystemId,
                    currency: data.currency,
                };
                return this.mutate("ccbillPurchaseDeposit", { data: tokenizedPurchaseData }, this.getFragment("Transaction"));
            }
            else {
                return this.mutate("ccbillPurchaseDeposit", { data }, this.getFragment("Transaction"));
            }
        });
    }
    purchaseRecurring({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (data.billingDetails !== undefined) {
                const tokenizedBillingDetails = Object.assign(Object.assign({}, (yield this.tokenizeCreditCard(data.paymentSystemId, data.billingDetails))), { saveCard: data.billingDetails.saveCard });
                const tokenizedPurchaseData = {
                    billingDetails: tokenizedBillingDetails,
                    subject: data.subject,
                    paymentSystemId: data.paymentSystemId,
                    currency: data.currency,
                };
                return this.mutate("ccbillPurchaseRecurring", { data: tokenizedPurchaseData }, this.getFragment("SubscriptionDetails"));
            }
            else {
                return this.mutate("ccbillPurchaseRecurring", { data }, this.getFragment("SubscriptionDetails"));
            }
        });
    }
}
exports.CCBillPurchaseProvider = CCBillPurchaseProvider;
//# sourceMappingURL=CCBillPurchaseProvider.js.map